import { Component, ProvideReactive, Vue } from 'vue-property-decorator';
import WithRender from './app.html';
import { isCurrentlyFoundingDay } from '@/utils/global';

@WithRender
@Component
export default class App extends Vue {
  @ProvideReactive()
  get isFoundingDay() {
    return isCurrentlyFoundingDay();
  }
}
